import { Import } from 'components/product/product-import/import/Import'
import { useEffect, useState } from 'react'
import { API_PRODUCT_IMPORT } from 'services/apiProductImport'
import { useFetch } from 'services/useFetch'

export const ImportContainer = ({ payload, onChangeStep, setImportResultData }) => {
    const [percentage, setPercentage] = useState(0)
    const { fetching: importData, data: response, isLoading } = useFetch(API_PRODUCT_IMPORT.IMPORT)

    useEffect(() => {
        if (percentage === 10) {
            const newPayload = {
                ...payload,
                mapping_fields: payload?.mapping_fields?.map((item) => {
                    return { ...item, db_col: item?.db_col?.value }
                }),
            }
            importData(newPayload, null, { 'Content-Type': 'multipart/form-data' })
                .then()
                .catch(() => onChangeStep(1))
        }
    }, [percentage])

    useEffect(() => {
        let timeout = null
        if (percentage <= 80) {
            timeout = setTimeout(() => {
                setPercentage(percentage + 10)
            }, 1000)
        } else if (!isLoading && response?.data) {
            timeout = setTimeout(() => {
                if (percentage === 100) {
                    setImportResultData(response?.data)
                    onChangeStep(4)
                } else {
                    setPercentage(percentage + 10)
                }
            }, 1000)
        }

        return () => {
            clearTimeout(timeout)
        }
    }, [percentage, isLoading])

    return <Import percentage={percentage} />
}
